import { ClassCard } from '@features/schedule/ui/class-сard/class-сard';
import s from './appointments-list.module.scss';

export const AppointmentsList = ({ isFetching, appointments, isTeacher }) => {
  if (isFetching) {
    return <div className={s.loadingState}>Загрузка...</div>;
  }

  if (appointments.length === 0) {
    return (
      <div className={s.emptyState}>
        <span>Занятий нет</span>
      </div>
    );
  }

  return (
    <div className={s.appointmentsList}>
      {appointments.map((apt) => (
        <ClassCard
          key={apt.id || apt.starts_at}
          {...apt}
        />
      ))}
    </div>
  );
};
